<!-- eslint-disable vuejs-accessibility/anchor-has-content -->
<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<template>
  <form @submit.prevent v-if="filter">
    <div class="w-100 mb-4">
      <div>
        <div>
            
          <button type="submit" @click="onSearch" class="btn btn-outline-secondary" hidden>
            <i class="fa fa-search"></i>
          </button>
        </div>
        <div class="search-box w-100">
          <input type="text" :placeholder="tab.type === 'Contract' ? 'رقم وثيقة العقد - اسم العقد' : 'رقم الطلب'"
            class="form-control px-10" dir="rtl" v-model="filter.contractName"
            @input="showClearIcon = !!(filter.contractName)"  />


          <a @click="showAdvancedSearch = !showAdvancedSearch" dir="rtl">
            <i :class="['far', 'fa-filter', 'filter-icon', { 'text-primary': showAdvancedSearch }]">
              <i v-if="showDataFilteredIndicator" class="fas fa-circle"></i>
              <b class="filter-text-padding">تصفية</b>
            </i>
          </a>
          <a @click="onClear" v-if="showClearIcon">
            <i class="fal fa-times text-danger clear-icon fa-lg"></i>
          </a>
          <i class="fal fa-search right-icon"></i>
        </div>
      </div>
      <div class="filter-container-box">
        <transition name="slide">
          <div class="w-100 px-10 pb-5 pt-2 filter-container-border" v-if="showAdvancedSearch">
            <div class="d-flex" v-if="tab.type === 'Request'">
              <div class="col-lg-4 col-md-4 col-sm-12 mb-1">
                <label for="inputEmail4" class="pb-2">نوع الطلب</label>
                <v-select :items="requestTypes" v-model="filter.requestTypeIds" item-text="name" item-value="id" multiple
                  solo clearable hide-details="'auto'" @change="onRequestTypeChanged"></v-select>
              </div>
            </div>
            <div class="d-flex">
              <div class="col-lg-4 col-md-4 col-sm-12 ml-4 mb-1">
                <label for="inputEmail4" class="pb-2">نوع الطرف</label>
                <v-select :items="tarafTypes" v-model="filter.tarafTypeIds" item-text="name" item-value="id" multiple solo
                  clearable hide-details="'auto'" @change="onTarafChanged"></v-select>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 mb-1" v-if="tab.type === 'Contract'">
                  <label for="inputEmail4" class="pb-2">حالة العقد</label>
                <v-select :items="contractStatuses" v-model="filter.contractStatusIds" item-text="name" item-value="id"
                  multiple solo clearable hide-details="'auto'" @change="onContractStatusChanged"></v-select>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 mb-1" v-if="tab.type === 'Request'">
                <label for="inputEmail4" class="pb-2">حالة الطلب</label>
                <v-select :items="requestStatuses" v-model="filter.requestStatusIds" item-text="name" item-value="id"
                  multiple solo clearable hide-details="'auto'" @change="onRequestStatusChanged"></v-select>
              </div>
            </div>
            <div class="w-100" v-if="tab.type === 'Request'">
              <label class="pr-3 text-primary font-weight-bold">تاريخ إنشاء
                الطلب</label>
              <div class="d-flex">
                <div class="ml-4 col-lg-4 col-md-6 col-sm-12 mb-2">
                  <DropDownCalendarComponent label="من تاريخ" :isGregorian="false" :futureYearsCount="56"
                    :yearsCount="10"
                    :selectedDate="filter.issueDate.dateFrom.isGregorian ? filter.issueDate.dateFrom.gregDate : filter.issueDate.dateFrom.hijriDate"
                    @dateChanged="onIssueDateFromChanged">
                  </DropDownCalendarComponent>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 mb-2">
                  <DropDownCalendarComponent :key="filter.issueDate.dateFrom.hijriDate" label="إلى تاريخ"
                    :yearsCount="100" :isGregorian="false" :futureYearsCount="56"
                    :minDate="filter.issueDate.dateFrom.hijriDate"
                    :selectedDate="filter.issueDate.dateTo.isGregorian ? filter.issueDate.dateTo.gregDate : filter.issueDate.dateTo.hijriDate"
                    @dateChanged="onIssueDateToChanged">
                  </DropDownCalendarComponent>
                </div>
              </div>
            </div>
            <div class="w-100" v-if="tab.type === 'Contract'">
              <label class="pr-3 text-primary font-weight-bold">تاريخ بداية العقد</label>
              <div class="d-flex">
                <div class="ml-4 col-lg-4 col-md-6 col-sm-12 mb-2">
                  <DropDownCalendarComponent label="من تاريخ" :isGregorian="false" :futureYearsCount="56"
                    :yearsCount="100"
                    :selectedDate="filter.startDate.dateFrom.isGregorian ? filter.startDate.dateFrom.gregDate : filter.startDate.dateFrom.hijriDate"
                    @dateChanged="onStartDateFromChanged">
                  </DropDownCalendarComponent>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 mb-2">
                  <DropDownCalendarComponent :key="filter.startDate.dateFrom.hijriDate" label="إلى تاريخ"
                    :yearsCount="100" :isGregorian="false" :futureYearsCount="56"
                    :minDate="filter.startDate.dateFrom.hijriDate"
                    :selectedDate="filter.startDate.dateTo.isGregorian ? filter.startDate.dateTo.gregDate : filter.startDate.dateTo.hijriDate"
                    @dateChanged="onStartDateToChanged">
                  </DropDownCalendarComponent>
                </div>
              </div>
              <label class="pr-3 text-primary font-weight-bold">تاريخ نهاية العقد</label>
              <div class="d-flex">
                <div class="ml-4 col-lg-4 col-md-6 col-sm-12 mb-2">
                  <DropDownCalendarComponent label="من تاريخ" :isGregorian="false" :futureYearsCount="56"
                    :yearsCount="100"
                    :selectedDate="filter.endDate.dateFrom.isGregorian ? filter.endDate.dateFrom.gregDate : filter.endDate.dateFrom.hijriDate"
                    @dateChanged="onEndDateFromChanged">
                  </DropDownCalendarComponent>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 mb-2">
                  <DropDownCalendarComponent :key="filter.endDate.dateFrom.hijriDate" label="إلى تاريخ" :yearsCount="100"
                    :isGregorian="false" :futureYearsCount="56" :minDate="filter.endDate.dateFrom.hijriDate"
                    :selectedDate="filter.endDate.dateTo.isGregorian ? filter.endDate.dateTo.gregDate : filter.endDate.dateTo.hijriDate"
                    @dateChanged="onEndDateToChangedChanged">
                  </DropDownCalendarComponent>
                </div>
              </div>
            </div>
            <div class="d-flex pr-3">
              <a class="btn btn-outline-primary waves-effect waves-light px-8 py-1 ml-3" @click="onReset">إعادة
                تعيين</a>
              <a class="btn button--greenFill px-8 py-1" @click="onSearch">بحث</a>
            </div>
          </div>
        </transition>
      </div>
    </div>

  </form>
</template>
<script lang="ts">
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';

import { Tab } from './tab.model';
import { FilterName, createContractFilter, createRequestFilter } from '@/models/contractFilterModel';
import { DDCalendarDate } from '@/models/common';
import DropDownCalendarComponent from '@/components/dropDownCalendar.vue';
import { ContractStatusEnum, ContractStatusEnumDisplayNames } from '@/enums/contract-status.enum';
import { TarafTypeEnum, TarafTypeEnumDisplayNames } from '@/enums/tarafTypeEnum';

@Component({
  components: {
    DropDownCalendarComponent,
  },
})
export default class SearchComponent extends Vue {
  /** Used to determine the selected tab. */
  @Prop({ default: { name: 'ApprovedContracts', type: 'Contract' }, required: true }) tab!: Tab;

  /** Holds the taraf types lookup data. */
  tarafTypes: { id: number, name: string }[] = [];

  /** Holds the contract statuses lookup data. */
  contractStatuses: { id: number, name: string }[] = [];

  /** Holds the request statuses lookup data. */
  requestStatuses: { id: number, name: string }[] = [];

  /** Holds the request types lookup data. */
  requestTypes: { id: number, name: string }[] = [];

  /** Used to toggle the advanced search panel. */
  showAdvancedSearch = false;

  /** Holds the search filter data for contracts and requests. */
  filter: any | null = null;

  /** Used to toggle the clear icon in the search textbox. */
  showClearIcon = false;

  /** Used to toggle a UI indicator if the data is filtered. */
  showDataFilteredIndicator = false;

  /** Used to give an indication whenever the search filter changed. */
  isFilterChanged = false;

  mounted(): void {
    this.filter = this.tab.type === 'Contract' ? createContractFilter() : createRequestFilter();
    this.populateTarafTypeLookup();
    this.populateContractStatusLookup();
    this.populateRequestStatusLookup(this.tab.name);
    this.populateRequestTypeLookup();
  }

  /**
   * Emits the current filter.
   */
  onSearch(): void {
    this.$emit('search', this.filter);
  }

  /**
   * Resets the simple search filter and emits the current filter.
   */
  onClear(): void {
    // Reset the basic search form data.
    this.resetSearchText();

    if (!this.showAdvancedSearch) {
      // Perform search and populate the list.
      this.onSearch();
    }
  }

  /**
   * Fires when the issue date from is changed.
   * @param date The date object.
   */
  onIssueDateFromChanged(date: DDCalendarDate): void {
    this.filter.issueDate.dateFrom = date;
    this.filter.issueDate.dateTo = {} as DDCalendarDate;
  }

  /**
   * Fires when the issue date to is changed.
   * @param date The date object.
   */
  onIssueDateToChanged(date: DDCalendarDate): void {
    this.filter.issueDate.dateTo = date;
  }

  /**
   * Fires when the start date from is changed.
   * @param date The date object.
   */
  onStartDateFromChanged(date: DDCalendarDate): void {
    this.filter.startDate.dateFrom = date;
    this.filter.endDate.dateTo = {} as DDCalendarDate;
  }

  /**
   * Fires when the start date to is changed.
   * @param date The date object.
   */
  onStartDateToChanged(date: DDCalendarDate): void {
    this.filter.startDate.dateTo = date;
  }

  /**
   * Fires when the end date from is changed.
   * @param date The date object.
   */
  onEndDateFromChanged(date: DDCalendarDate): void {
    this.filter.endDate.dateFrom = date;
    this.filter.endDate.dateTo = {} as DDCalendarDate;
  }

  /**
   * Fires when the end date to is changed.
   * @param date The date object.
   */
  onEndDateToChangedChanged(date: DDCalendarDate): void {
    this.filter.endDate.dateTo = date;
  }

  /**
   * Fires when the contract select status is changed.
   * @param options The selected options.
   * @returns void
   */
  onContractStatusChanged(options: any[]): void {
    if (!options.length) {
      this.filter.contractStatusIds = [0];
      return;
    }

    const allSelected = options[options.length - 1] === 0;
    this.filter.contractStatusIds = this.filter.contractStatusIds.filter((x: number) => (allSelected ? x === 0 : x !== 0));
  }

  /**
   * Fires when the contract select status is changed.
   * @param options The selected options.
   * @returns void
   */
  onRequestStatusChanged(options: any[]): void {
    if (!options.length) {
      this.filter.requestStatusIds = [0];
      return;
    }

    const allSelected = options[options.length - 1] === 0;
    this.filter.requestStatusIds = this.filter.requestStatusIds.filter((x: number) => (allSelected ? x === 0 : x !== 0));
  }

  /**
   * Fires when the select taraf is changed.
   * @param options The selected options.
   * @returns void
   */
  onTarafChanged(options: any[]): void {
    if (!options.length) {
      this.filter.tarafTypeIds = [0];
      return;
    }

    const allSelected = options[options.length - 1] === 0;
    this.filter.tarafTypeIds = this.filter.tarafTypeIds.filter((x: number) => (allSelected ? x === 0 : x !== 0));
  }

  /**
   * Fires when the select request type is changed.
   * @param options The selected options.
   * @returns void
   */
  onRequestTypeChanged(options: any[]): void {
    if (!options.length) {
      this.filter.requestTypeIds = [0];
      return;
    }

    const allSelected = options[options.length - 1] === 0;
    this.filter.requestTypeIds = this.filter.requestTypeIds.filter((x: number) => (allSelected ? x === 0 : x !== 0));
  }

  /**
   * Resets the advanced search filter and repopulate the list.
   */
  onReset(): void {
    // Reset the filter controls.
    this.reset(this.tab);

    // Emit a reset event.
    this.$emit('reset', this.filter);
  }

  /**
   * Resets all search parameters for a given tab.
   * @param tab The current active tab.
   */
  reset(tab: Tab): void {
    this.resetSearchText();
    this.showAdvancedSearch = false;
    this.filter = tab.type === 'Contract' ? createContractFilter() : createRequestFilter();
  }

  @Watch('filter', { immediate: false, deep: true })
  onFilterChanged(newFilter: any) {
    const currentFilter = JSON.stringify(newFilter);
    const originalFilter = JSON.stringify(newFilter.type === 'Contract' ? createContractFilter() : createRequestFilter());
    this.isFilterChanged = currentFilter !== originalFilter;
  }

  @Watch('tab')
  onTabChanged(newTab: Tab) {
    this.reset(newTab);
    this.populateRequestStatusLookup(newTab.name);
  }

  // Private methods.

  /**
   * Populate the contract status lookup select list.
   */
  private populateContractStatusLookup(): void {
    this.contractStatuses.push({ id: 0, name: 'الكل' });
    this.contractStatuses.push({ id: ContractStatusEnum.Valid, name: ContractStatusEnumDisplayNames[ContractStatusEnum.Valid] });
    this.contractStatuses.push({ id: ContractStatusEnum.Expired, name: ContractStatusEnumDisplayNames[ContractStatusEnum.Expired] });
    this.contractStatuses.push({ id: ContractStatusEnum.Closed, name: ContractStatusEnumDisplayNames[ContractStatusEnum.Closed] });
    this.contractStatuses.push({ id: ContractStatusEnum.Cancelled, name: ContractStatusEnumDisplayNames[ContractStatusEnum.Cancelled] });
  }

  /**
   * Populate the request status lookup select list.
   * @param filterName The filter name.
   */
  private populateRequestStatusLookup(filterName: FilterName): void {
    this.requestStatuses = [{ id: 0, name: 'الكل' }];
    this.requestStatuses.push({ id: ContractStatusEnum.Pending, name: ContractStatusEnumDisplayNames[ContractStatusEnum.Pending] });

    if (filterName === 'MyRequests') {
      this.requestStatuses.push({ id: ContractStatusEnum.Cancelled, name: ContractStatusEnumDisplayNames[ContractStatusEnum.Cancelled] });
      this.requestStatuses.push({ id: ContractStatusEnum.Rejected, name: ContractStatusEnumDisplayNames[ContractStatusEnum.Rejected] });
    }
  }

  /**
   * Populate the taraf type select list.
   */
  private populateTarafTypeLookup(): void {
    for (const key in TarafTypeEnum) {
      if (Number.isNaN(Number(key))) {
        const id = parseInt(TarafTypeEnum[key], 10);
        const name = TarafTypeEnumDisplayNames[id];
        this.tarafTypes.push({ id, name });
      }
    }

    this.tarafTypes = [{ id: 0, name: 'الكل' }, ...this.tarafTypes];
  }

  /**
   * Populates the request type select list.
   */
  private populateRequestTypeLookup(): void {
    this.requestTypes.push({ id: 0, name: 'الكل' });
    this.requestTypes.push({ id: 1, name: 'توثيق عقد' });
    this.requestTypes.push({ id: 2, name: 'تسوية عقد' });
  }

  /**
   * Resets the basic search parameters.
   */
  private resetSearchText(): void {
    this.filter.contractName = '';
    this.showDataFilteredIndicator = false;
    this.showClearIcon = false;
  }
}
</script>
